import PrivacyPolicies from "pages/LandingPages/PrivacyPolicies";

export default function PrivacyPoliciesPage() {
  return <PrivacyPolicies />;
}
